import React, { useState } from "react";
import Modal from "../components/Modal";


const ContactUs = () => {
	const[isShow, setIsShow] = useState(false);
	const handleClick = ()=> {
		setIsShow(true);
		
	}

  return (
    <div className="w-full h-screen flex items-center justify-center">
		<h1 className="font-interMedium text-2xl text-[#101828]">Contact Us</h1>
	  </div>
  );
};

export default ContactUs;